<template>
  <!-- images without lazy loading -->
  <div>
    <img
      v-show="showPlaceholder"
      src="/assets/placeholder.svg"
      :alt="alt"
      key="placeholder"
      ref="images"
      class="image__thumb image__thumb--placeholder"
      :width="width"
      :height="height"
      fetchpriority="high"
      loading="eager"
    >
    <img
      class="image__thumb"
      :src="srcImage"
      :alt="alt"
      ref="images"
      loading="eager"
      fetchpriority="high"
      :width="width"
      :height="height"
      style="opacity: 0;"
      @load="(event) => {
        showPlaceholder = false;
        event.target.style.opacity = 1;
      }"
      @error="$event.target.style.display = 'none'"
    >
  </div>
</template>

<script async>
export default {
  props: {
    image: {
      type: Object
    },
    alt: {
      type: String
    },
    width: {
      type: Number
    },
    height: {
      type: Number
    }
  },
  data () {
    return {
      showPlaceholder: true
    }
  },
  computed: {
    srcImage () {
      return this.image.src ? this.image.src : '/assets/placeholder.svg'
    }
  }
}
</script>
<style lang="scss" scoped>
.image__thumb {
  max-width: 100%;
  position: absolute;
  top: 50%;
  left: 50%;
  width: auto;
  height: inherit;
  -webkit-transform: translate3d(-50%, -50%, 0);
  transform: translate3d(-50%, -50%, 0);
  pointer-events: none;
  &--placeholder{
    width: 66.8%;
    height: auto;
  }
}
</style>
